import React, {Fragment, useState, useEffect} from 'react'
import { Row, Col, Button, Form, Modal } from 'react-bootstrap'
import { Auth, LoadingComponent} from 'recupero-comunes'
import { formatoMontoCLP } from '../../common/Formatos'
import { serviceConfiguracionForm, serviceGetDocumento } from '../../api/api-solicitud-honorarios';
import { descargarArchivo } from '../../common/descargarArchivo';

const ModalDetalleHonorario = ({showModalDetalle, handleCloseModalDetalleHo, selectedRow}) => {
    
    const [loading, setLoading]=useState(false)
    const { rutOrganizacion } = Auth.currentUser()

    const [idFolioDoctoHito, setIdFolioDoctoHito] = useState(null);

    const [cfg_form97, setCfg_form] = useState({});

    useEffect(() => {
        if (selectedRow && selectedRow['idFolioDoctoHito']) {
            setIdFolioDoctoHito(selectedRow['idFolioDoctoHito']);
        } else {
            setIdFolioDoctoHito(null);
        }
    }, [selectedRow]);

    useEffect(() => {     
            if (showModalDetalle){ 
                getCfgForm(); 
            }
    }, [showModalDetalle])
    
    const getCfgForm = async () => {
        const query = Buffer.from(JSON.stringify({ rutcia: rutOrganizacion, idform: 97})).toString('base64');
        const response = await serviceConfiguracionForm(query);
        setCfg_form(response);
    }

    const verDocumento = async (folioDocumento) => {

        try {        
            if (folioDocumento) {
                setLoading(true); 
                let parametros = JSON.stringify({
                    idCaso: selectedRow.idCaso,
                    idImplicadoCaso: 0,
                    idCompania: selectedRow.idCompania,
                    idfolioCarga: folioDocumento
                });
                console.log("en handleDocumento...", parametros);
                let query = Buffer.from(parametros).toString('base64')

                const response = await serviceGetDocumento(query);
                setLoading(false);

                descargarArchivo(response);
            }
        } catch (error) {
            console.log("error:", error);
            setLoading(false);
        }
    }
    return (
        <>
        <style type='text/css'>
            {`
                .btn-confirmar{
                  background-color: #C14B49;
                  color: #FFFFFF;
                  width: 140px;
                  padding:6px 0px 6px 0px;
                }
                .btn-confirmar:hover{
                  background-color: #F6897E;
                  color: #FFFFFF;
                }
                .btn-cancelar {
                  background-color: #00aeab;
                  color: #FFFFFF;  
                  width: 140px;
                  padding:6px 0px 6px 0px;
                }
                .btn-cancelar:hover{
                  background-color: #87c9dc;
                  color: #FFFFFF;
                }         
            `}
        </style>
        <div> 
            <LoadingComponent show={loading}/>
            <Modal show={showModalDetalle} onHide={handleCloseModalDetalleHo} backdrop='static' size='xl'>
                <Modal.Header closeButton style={{background:'rgb(226, 227, 229)'}}>
                    <Modal.Title>
                        {(cfg_form97 && cfg_form97["modal-detalle-hono-title"]) ? cfg_form97["modal-detalle-hono-title"] : 'Detalle Honorario'}
                    </Modal.Title>          
                </Modal.Header>
                <Modal.Body>
                    <Form.Group className="mb-4">
                        <Row>
                            <Col md="2"><strong>{cfg_form97 && cfg_form97['modal-detalle-hono-siniestro']}</strong> <div>{selectedRow.siniestro}</div></Col>
                            <Col md="2"><strong>{cfg_form97 && cfg_form97['modal-detalle-hono-placa']}</strong> <div>{selectedRow.patente}</div></Col>
                            <Col md="3"><strong>{cfg_form97 && cfg_form97['modal-detalle-hono-origen']}</strong> <div>{selectedRow.glosaOrigen}</div></Col>
                            <Col md="3"><strong>{cfg_form97 && cfg_form97['modal-detalle-hono-concepto-factura']}</strong> <div>{selectedRow.glosaConcepto}</div></Col>
                            <Col md="2"><strong>{cfg_form97 && cfg_form97['modal-detalle-hono-fecha-hito']}</strong> <div>{selectedRow.fechaHabilitadoFmt}</div></Col>
                        </Row>
                        <br></br>
                            <Row>
                            <Col md="2"><strong>{cfg_form97 && cfg_form97['modal-detalle-hono-nro-factura']}</strong> 
                                <div>{selectedRow.nroFactura}</div>
                            </Col>
                            <Col md="2"><strong>{cfg_form97 && cfg_form97['modal-detalle-hono-fecha-factura']}</strong> 
                                <div>{selectedRow.fechaFacturaFmt}</div>
                            </Col>
                            <Col md="3"><strong>{cfg_form97 && cfg_form97['modal-detalle-hono-neto-factura']}</strong> <div>{formatoMontoCLP(selectedRow.montoNetoFacturado)}</div></Col>
                            <Col md="3"><strong>{cfg_form97 && cfg_form97['modal-detalle-hono-iva']}</strong> <div>{formatoMontoCLP(selectedRow.montoIva)}</div></Col>
                            <Col md="2"><strong>{cfg_form97 && cfg_form97['modal-detalle-hono-total-factura']}</strong> <div>{formatoMontoCLP(selectedRow.montoTotalFacturar)}</div></Col>
                        </Row>
                        <br></br>
                        <Row>                            
                            <Col md='2'>
                                <strong>{cfg_form97 && cfg_form97['modal-detalle-hono-docto-hito']}</strong> 
                                <a 
                                    href="#"
                                    onClick={(e) => {
                                        e.preventDefault();
                                        if (!idFolioDoctoHito) {                                
                                            return;
                                        }
                                        verDocumento(idFolioDoctoHito); 
                                    }}  
                                    style={{ display: 'flex', alignItems: 'center', marginTop: '10px', 
                                        color: !idFolioDoctoHito ? 'gray' : 'red',
                                        pointerEvents: !idFolioDoctoHito ? 'none' : 'auto',
                                        opacity: !idFolioDoctoHito ? 0.5 : 1
                                    }}
                                    >
                                    {/* SVG como ícono */}
                                    <svg xmlns="http://www.w3.org/2000/svg" width="30" height="30" fill="currentColor" className="bi bi-file-earmark-pdf" viewBox="0 0 20 20">
                                        <path d="M14 14V4.5L9.5 0H4a2 2 0 0 0-2 2v12a2 2 0 0 0 2 2h8a2 2 0 0 0 2-2M9.5 3A1.5 1.5 0 0 0 11 4.5h2V14a1 1 0 0 1-1 1H4a1 1 0 0 1-1-1V2a1 1 0 0 1 1-1h5.5z"/>
                                        <path d="M4.603 14.087a.8.8 0 0 1-.438-.42c-.195-.388-.13-.776.08-1.102.198-.307.526-.568.897-.787a7.7 7.7 0 0 1 1.482-.645 20 20 0 0 0 1.062-2.227 7.3 7.3 0 0 1-.43-1.295c-.086-.4-.119-.796-.046-1.136.075-.354.274-.672.65-.823.192-.077.4-.12.602-.077a.7.7 0 0 1 .477.365c.088.164.12.356.127.538.007.188-.012.396-.047.614-.084.51-.27 1.134-.52 1.794a11 11 0 0 0 .98 1.686 5.8 5.8 0 0 1 1.334.05c.364.066.734.195.96.465.12.144.193.32.2.518.007.192-.047.382-.138.563a1.04 1.04 0 0 1-.354.416.86.86 0 0 1-.51.138c-.331-.014-.654-.196-.933-.417a5.7 5.7 0 0 1-.911-.95 11.7 11.7 0 0 0-1.997.406 11.3 11.3 0 0 1-1.02 1.51c-.292.35-.609.656-.927.787a.8.8 0 0 1-.58.029m1.379-1.901q-.25.115-.459.238c-.328.194-.541.383-.647.547-.094.145-.096.25-.04.361q.016.032.026.044l.035-.012c.137-.056.355-.235.635-.572a8 8 0 0 0 .45-.606m1.64-1.33a13 13 0 0 1 1.01-.193 12 12 0 0 1-.51-.858 21 21 0 0 1-.5 1.05zm2.446.45q.226.245.435.41c.24.19.407.253.498.256a.1.1 0 0 0 .07-.015.3.3 0 0 0 .094-.125.44.44 0 0 0 .059-.2.1.1 0 0 0-.026-.063c-.052-.062-.2-.152-.518-.209a4 4 0 0 0-.612-.053zM8.078 7.8a7 7 0 0 0 .2-.828q.046-.282.038-.465a.6.6 0 0 0-.032-.198.5.5 0 0 0-.145.04c-.087.035-.158.106-.196.283-.04.192-.03.469.046.822q.036.167.09.346z"/>
                                    </svg>
                                </a>
                            </Col>
                            <Col md="2"><strong>{cfg_form97 && cfg_form97['modal-detalle-hono-situacion']}</strong> <div>{selectedRow.glosaSituacion}</div></Col>
                            <Col md="8"><strong>{cfg_form97 && cfg_form97['modal-detalle-hono-observacion']}</strong> <div>{selectedRow.comentario}</div></Col>
                       </Row>             
                    </Form.Group>
                </Modal.Body>
                <Modal.Footer> 
                    <Button className='me-md-2' variant='cancelar' type='button' onClick={handleCloseModalDetalleHo}>{cfg_form97 && cfg_form97['modal-detalle-hono-btn-cancelar']}</Button>
                </Modal.Footer>
            </Modal>
        </div>
        </>
    )
}
export default ModalDetalleHonorario
const getBase64 = (file) => {
    return new Promise(resolve => {
        let reader = new FileReader();
        // Convert the file to base64 text
        reader.readAsDataURL(file);
        reader.onload = () => {
            resolve(reader.result);
        };
        reader.onerror = (error) => reject(error);
    });
};